module.exports = __webpack_public_path__ + "static/media/faster.23308f27.webp";